
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#EDF1F7',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        '& .MuiTypography-root': {
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
        },
        '& .MuiButton-root': {
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif !important",
        }
    },
    sidebar: {
        width: '280px',
        background: 'linear-gradient(180deg, #f54814 0%, #FF8A00 100%)',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        height: '100vh',
        left: 0,
        top: 0,
        zIndex: 100,
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    sidebarLogoContainer: {
        backgroundColor: '#fff',
        borderRadius: '0 0 140px 0 / 0 0 100px 0',
        padding: '5px 24px 5px 6px',
        flexShrink: 0,
        width: '54%',
        boxSizing: 'border-box',
    },
    logo: {
        height: '41px',
    },
    navItems: {
        flexGrow: 1,
        marginTop: '20px',
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 25px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        margin: '4px 15px',
        borderRadius: '12px',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.15)',
            transform: 'translateX(5px)',
        },
    },
    navItemActive: {
        backgroundColor: 'rgba(255,255,255,0.25)',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    },
    navText: {
        marginLeft: '15px !important',
        fontSize: '18px !important',
        fontWeight: '500 !important',
    },
    subNav: {
        paddingLeft: '95px !important',
        fontSize: '16px !important',
        color: 'rgba(255,255,255,0.8)',
        marginBottom: '10px !important',
        cursor: 'pointer',
        listStyle: 'none',
        '&:hover': {
            color: '#fff',
        },
    },
    mainContent: {
        marginLeft: '280px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
        },
    },
    mainContentInterior: {
        padding: '20px 60px',
        [theme.breakpoints.down('sm')]: {
            padding: '15px 15px',
        },
    },
    header: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '40px',
        position: 'relative',
    },
    headerTitle: {
        marginTop:'50px !important',
        fontSize: '36px !important',
        fontWeight: '800 !important',
        color: '#000',
    },
    profileIconBtn: {
        position: 'absolute !important',
        right: '15px',
        top: '40%',
        transform: 'translateY(-50%)',
    },
    profileIcon: {
        fontSize: '45px !important',
        color: '#666',
        cursor: 'pointer',
    },
    topRow: {
        display: 'grid',
        gridTemplateColumns: 'minmax(250px, 1fr) minmax(250px, 1fr) 2fr',
        gap: '20px',
        marginBottom: '30px',
        padding: '20px 40px',
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr',
            padding: '10px 0',
        },
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: '24px',
        padding: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        [theme.breakpoints.down('sm')]: {
            padding: '20px',
        },
    },
    cardIcon: {
        fontSize: '50px !important',
        marginBottom: '15px',
    },
    cardTitle: {
        fontSize: '24px !important',
        fontWeight: '800 !important',
        marginBottom: '10px !important',
    },
    cardDesc: {
        fontSize: '14px !important',
        color: '#666',
        marginBottom: '20px !important',
        lineHeight: '1.5 !important',
        minHeight: '42px',
    },
    baselineBtn: {
        background: '#0097b2 !important',
        color: '#fff !important',
        borderRadius: '12px !important',
        padding: '12px 40px !important',
        textTransform: 'none !important',
        fontWeight: '800 !important',
        fontSize: '16px !important',
    },
    createProgramBtn: {
        background: '#f54814 !important',
        color: '#fff !important',
        borderRadius: '12px !important',
        padding: '12px 40px !important',
        textTransform: 'none !important',
        fontWeight: '800 !important',
        fontSize: '16px !important',
        boxShadow: '0 4px 10px rgba(241, 90, 36, 0.3)',
    },
    insightsCard: {
        backgroundColor: '#1A1A1A',
        color: '#fff',
        borderRadius: '24px',
        padding: '30px',
        display: 'flex',
        flexDirection: 'column',
    },
    insightsTitle: {
        fontSize: '28px !important',
        fontWeight: '800 !important',
        textAlign: 'center',
        marginBottom: '30px !important',
    },
    insightsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '20px',
        flexGrow: 1,
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    insightItem: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    insightValue: {
        fontSize: '56px !important',
        fontWeight: '800 !important',
        color: '#FFB300',
        lineHeight: 1,
    },
    insightLabel: {
        fontSize: '12px !important',
        lineHeight: '1.4 !important',
        opacity: 0.8,
        margin: '10px 0 !important',
    },
    insightBtn: {
        background: '#fff !important',
        color: '#f54814 !important',
        borderRadius: '12px !important',
        padding: '12px 20px !important',
        textTransform: 'none !important',
        fontSize: '16px !important',
        fontWeight: '800 !important',
        marginTop: '15px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px !important',
            padding: '10px 15px !important',
        },
        '&:hover': {
            background: '#eee !important',
        },
    },
    sectionDivider: {
        margin: '30px -60px 30px !important',
        backgroundColor: '#d1d5db !important',
        height: '1px !important',
        [theme.breakpoints.down('sm')]: {
            margin: '20px 0 !important',
        },
    },
    overviewSection: {
        marginTop: '0px',
        padding: '20px 40px',
        textAlign: 'center',
    },
    overviewTitle: {
        fontSize: '30px !important',
        fontWeight: '800 !important',
        color: '#f54814',
        marginBottom: '40px !important',
    },
    overviewGrid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(280px, 1.3fr) 1fr 1fr 1fr 1fr',
        gap: '15px',
        marginBottom: '30px',
        alignItems: 'stretch',
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    },
    readinessCard: {
        background: '#8EB283',
        borderRadius: '32px',
        padding: '24px 15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
        minHeight: '220px',
        [theme.breakpoints.down('sm')]: {
           minHeight: '180px',
           padding: '15px 10px',
        }
    },
    readinessLabel: {
        fontSize: '19px !important',
        fontWeight: '800 !important',
        color: '#000',
        marginBottom: '2px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px !important',
        }
    },
    readinessScore: {
        fontSize: '55px !important',
        color: '#fff',
        fontWeight: '800 !important',
        lineHeight: 1,
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '42px !important',
        }
    },
    readinessDescription: {
        fontSize: '25px !important',
        fontWeight: '800 !important',
        color: '#fff',
        lineHeight: 1.2,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px !important',
        }
    },
    readinessSubText: {
        fontSize: '16px !important',
        fontWeight: '800 !important',
        color: '#000',
        fontStyle: 'italic',
    },
    statCard: {
        background: '#fff',
        borderRadius: '0px',
        padding: '28px 15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'space-between',
        height: '220px',
        boxShadow: 'none',
    },
    statLabel: {
        fontSize: '16px !important',
        fontWeight: '800 !important',
        color: '#000',
        marginBottom: '15px',
        maxWidth: '180px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1.3,
    },
    statValue: {
        fontSize: '55px !important',
        fontWeight: '800 !important',
        color: '#f54814',
        lineHeight: 1,
        marginTop: 'auto',
        marginBottom: '5px',
         [theme.breakpoints.down('sm')]: {
            fontSize: '42px !important',
        }
    },
    viewByProgramBtn: {
        background: '#000 !important',
        color: '#fff !important',
        padding: '12px 40px !important',
        borderRadius: '12px !important',
        fontWeight: '800 !important',
        textTransform: 'none !important',
        fontSize: '16px !important',
        marginTop: '20px !important',
    },
    dialogPaper: {
        borderRadius: '50px !important',
        padding: '60px 50px !important',
        maxWidth: '800px !important',
        width: '100% !important',
        textAlign: 'center',
        boxShadow: '0 10px 50px rgba(0,0,0,0.15) !important',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dialogText: {
        fontSize: '20px !important',
        lineHeight: '1.5 !important',
        color: '#222',
        marginBottom: '40px !important',
    },
    dialogHighlight: {
        fontWeight: '800',
        color: '#000',
    },
    dialogActions: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
    },
    dialogBtnStartOver: {
        background: '#0097b2 !important',
        color: '#fff !important',
        borderRadius: '12px !important',
        padding: '12px 40px !important',
        fontSize: '16px !important',
        fontWeight: '800 !important',
        textTransform: 'none !important',
        minWidth: '170px',
        boxShadow: '0 4px 10px rgba(0, 151, 178, 0.2)',
        [theme.breakpoints.down('md')]: {
            padding: '10px 0px !important',
            minWidth: '130px !important',
        },
    },
    dialogBtnContinue: {
        background: '#f54814 !important',
        color: '#fff !important',
        borderRadius: '12px !important',
        padding: '12px 40px !important',
        fontSize: '16px !important',
        fontWeight: '800 !important',
        textTransform: 'none !important',
        minWidth: '170px',
        boxShadow: '0 4px 10px rgba(245, 72, 20, 0.2)',
        [theme.breakpoints.down('md')]: {
            padding: '10px 0px !important',
            minWidth: '130px !important',
        },
    },
    guidanceCard: {
        position: 'fixed',
        left: '145px',
        bottom: '250px',
        zIndex: 2000,
        backgroundColor: '#fff',
        borderRadius: '50px',
        padding: '40px 60px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        maxWidth: '550px',
        textAlign: 'center',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            left: '20px',
            right: '20px',
            bottom: '20px',
            borderRadius: '25px',
            padding: '20px',
            maxWidth: 'none',
        },
    },
    guidanceText: {
        fontSize: '18px !important',
        fontWeight: '400 !important',
        color: '#333',
        lineHeight: '1.5 !important',
    },
    guidanceHighlight: {
        fontWeight: '900',
        color: '#000',
    },
}));

export default useStyles;
